import { render, staticRenderFns } from "./selectSimpleText.vue?vue&type=template&id=3333a3b5&"
import script from "./selectSimpleText.vue?vue&type=script&lang=ts&"
export * from "./selectSimpleText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports